module.exports = __webpack_public_path__ + "static/media/bell-icon.b24c42b3.svg";